module.exports = __webpack_public_path__ + "img/edge_patrimoine_pont.0184fadd.svg";